export enum screenWidths {
	sm = '576px',
	md = '768px',
	lg = '992px',
	xl = '1200px',
	xxl = '1440px',
	xxxl = '1600px'
}
